module.exports = new __parcel__URL__("battlepass_home_button.be2103ce.png").toString();